import React from 'react'
import { Typography, Button, Grid } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import error from "../../assets/images/error.png";

export default function TechnicalError() {
    const navigate = useNavigate();
  return (
    <Grid style={{ height: "100vh" }}>
        {/* <Navbar cart />
        <Grid
          container
          justifyContent="center"
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            padding: "0.8rem",
            boxShadow: "0px 0px 9px",
            background: "white",
          }}
        >
          <Typography variant="h5" style={{ fontWeight: "bold" }}>
          Payment
            Failed
          </Typography>
        </Grid> */}
        <Grid
          container
          justifyContent="center"
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ paddingTop: "10rem" }}
        >
          <h3
            style={{
              fontFamily: "Satoshi",
              fontWeight: "900",
              marginBottom: "0rem",
              color: "#b51515",
            }}
          >
          Technical Error
          </h3>
          <Grid container justifyContent="center" style={{ margin: "1rem" }}>
            <img alt='error' src={error} style={{ width: "45%" }}></img>
          </Grid>
          <Typography>
            <Typography style={{ marginTop: "1rem" }}>
           Something went wrong.<br/>
             Please try after some time.
            </Typography>
          </Typography>
          <Grid
            container
            justifyContent="space-evenly"
            style={{ paddingTop: "2rem" }}
          >
            <Button
              style={{
                borderRadius: "0.6rem",

                color: "black",
              }}
              variant="contained"
              onClick={() => navigate("/")}
            >
             
            Close
            </Button>
          
          </Grid>
        </Grid>
      </Grid>
  )
}
